import React from "react";
import { FormattedMessage } from "react-intl";

export default [
    {
        name: "truckClass",
        label: <FormattedMessage id="truck-type.class" />,
        type: "String",
    },
    {
        name: "box",
        label: <FormattedMessage id="truck-type.box" />,
        type: "string",
    },
    {
        name: "condition",
        label: <FormattedMessage id="truck-type.condition" />,
        type: "string",
    },
    {
        name: "capacityInTon",
        label: <FormattedMessage id="truck-type.capacity-in-ton" />,
        type: "number",
    },
    {
        name: "numOfPallets",
        label: <FormattedMessage id="truck-type.pallets-count" />,
        type: "number",
    },
    {
        name: "createdAt",
        label: <FormattedMessage id="truck-type.creation-date" />,
        type: "date",
    },
];
